<template>
    <fieldset>
        <div id="company-title" class="title bg-success">
            <div> Playbook</div>
        </div>
        <div class="col-auto">
            <label for="pop" class="col-form-label">Nome</label>
        </div>
        <div class="col-auto">
            <input type="text" v-model="playbook.name" class="form-control form-control-sm">
        </div>
        <div class="col-auto">
            <label for="pop" class="col-form-label">Ações</label>
        </div>
    </fieldset>
    <PlaybookEdit :active-jump="false" v-if="loaded" v-model="playbook"></PlaybookEdit>
</template>

<script>
import PlaybookEdit from './PlaybookEdit.vue';
import { playbookService } from '@/services/backend/ApiService';

export default {
    components: {
        PlaybookEdit
    },
    data() {
        return {
            loaded: false,
            playbook: {
                id: this.$route.params.id
            }
        }
    },
    async mounted() {
        this.playbook = await playbookService.findOne(this.playbook.id);
        this.loaded = true;
    },
}
</script>

<style scoped></style>